import React, { useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'
import { classNames } from 'primereact/utils'
import { Password } from "primereact/password"
import { InputText } from 'primereact/inputtext'
import { InputMask } from "primereact/inputmask"
import { Link } from 'react-router-dom'
import { Checkbox } from "primereact/checkbox"
import server from 'infra/server'
import { getMessagesFromError } from 'helper/error'

export default function Register() {

    const [message, setMessage] = useState('')
    const toast = useRef(null)

    // const defaultValues = [{ email: 'ivan@fizaqui.com.br' }, { value: '123' }]
    const defaultValues = []
    const form = useForm({ defaultValues })

    const errors = form.formState.errors
    const toastIf = (expression, detail) => {
        if (expression) {
            toast.current.show({ severity: 'error', summary: 'Ops!', detail })
            return true
        }
        return false
    }

    const [loading, setLoading] = useState(false)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768 || window.innerHeight < 420)

    useEffect(() => {
        document.body.style.backgroundColor = '#ffffff'
        return () => {
            document.body.style.backgroundColor = ''
        }
    }, [])


    const onSubmit = (data) => {

        setLoading(true)
        setMessage('')

        if (toastIf(data.email.length < 9, 'E-mail muito curto')) {
        } else if (toastIf(data.celular.length < 10, 'Celular muito curto')) {
        } else if (toastIf(data.password.length < 5, 'Senha muito curta')) {
        } else if (toastIf(data.password !== data.password_repeat, 'As senhas devem ser iguais')) {
        } else if (toastIf(!data.termos, 'Você deve aceitar os termos')) {
        } else {
            toast.current.show({ severity: 'info', summary: 'Registro', detail: 'Registrando...' })
            const postData = {
                "nomeUsu": data.nome,
                "telcelUsu": data.celular,
                "loginUsu": data.email,
                "password": data.password,
                "urlconfirmUsu": window.location.origin + '/confirmregister'
            }
            server().post('registerstart', postData).then((response) => {

                toast.current.clear()

                setMessage('Confirme o registro no e-mail que foi enviado para você!')

                // navigate('/login', { state: { msgRegistered: 'Confirme o registro no e-mail que foi enviado para você!' } })
                // form.reset()

            }).catch((err) => {
                toast.current.clear()
                const detail = getMessagesFromError({ err })
                setMessage(detail)
            }).finally(() => {
                setLoading(false)
            })

        }
    }

    const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>
    }

    return (
        <div className="flex flex-column md:flex-row bg-white h-screen">

            {/* Esquerda: Branding */}
            {isMobile ? (
                <></>
            ) : (
                < div className="md:w-6 border-0" >
                    <img src="/login-sup-esq.svg" className='border-0' alt="Arte superior esquerda" />
                    <div className='flex border-0 absolute' style={{ top: '50%', left: '25%' }}>
                        <img src="/logo.svg" className='' alt="Logo" style={{ width: '15%' }} />
                        <div>
                            <div className='text-7xl ml-4'>Fiz Aqui</div>
                            <div className='ml-5 mt-1 text-gray-400'>Enterprise Resource Planning</div>
                        </div>
                    </div>
                </div>
            )}

            {/* Direita: Formulário */}
            <div className={`border-0 w-full md:w-${isMobile ? 12 : 6} flex flex-column align-items-center`}>

                {/* Cabeçalho */}
                <div className="border-0 pb-8 border-green-500 p-0 w-full flex flex-column align-items-end relative">

                    <img className="absolute" src="/login-sup-dir.svg" alt="Arte superior direira" />
                    <div className="absolute flex flex-nowrap mt-2 mr-4 ext-white text-lg">
                        <Link id='redefinePassword' to="/redefinirsenha" className="text-white no-underline">Esqueci minha senha</Link>
                        <div className='mx-2 text-white'>|</div>
                        <Link id='addExtraBase' to="/adicionabaseextra" className="text-white no-underline">Adicionar base</Link>
                    </div>

                </div>

                {/* Formulário */}
                <div className="border-0 border-round h-full w-full flex flex-column align-items-center justify-content-center">

                    <div className='flex flex-column border-0 shadow-0 justify-content-center align-items-center border-round-2xl bg-white w-20rem'>

                        <Toast ref={toast} />
                        <h2 className="flex flex-row justify-content-start align-items-center text-900 mb-4">
                            <img src="/logo.svg" className='' alt="Logo" style={{ width: '9%' }} />
                            <div id='newAccount' className='ml-2 font-light'>Criar conta</div>
                        </h2>
                        <div className='fadeinleft text-logo-main'>
                            {message}
                        </div>

                        <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-column gap-1 w-20rem border-0">
                            <Controller
                                name="nome"
                                control={form.control}
                                rules={{
                                    required: 'Nome',
                                    validate: value => value.length > 4 || "Nome muito curto"
                                }}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.nome })}>
                                        </label>
                                        <InputText
                                            id={field.name}
                                            {...field}
                                            placeholder='Nome'
                                            inputMode="text"
                                            className={classNames("flex-1 border-2 border-round-2xl border-logo-main outline-none bg-transparent appearance-none text-gray-700 w-20rem px-3 py-2", { 'p-invalid': fieldState.error })}
                                        />
                                        {getFormErrorMessage(field.name)}
                                    </>
                                )}
                            />
                            <Controller
                                name="celular"
                                control={form.control}
                                rules={{ required: 'celular' }}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.celular })}>
                                        </label>
                                        <InputMask
                                            id={field.name}
                                            {...field}
                                            placeholder='Celular'
                                            inputMode="tel"
                                            mask="(99) 99999-9999"
                                            className={classNames("flex-1 border-2 border-round-2xl border-logo-main outline-none bg-transparent appearance-none text-gray-700 w-20rem px-3 py-2", { 'p-invalid': fieldState.error })}
                                        />
                                        {getFormErrorMessage(field.name)}
                                    </>
                                )}
                            />
                            <Controller
                                name="email"
                                control={form.control}
                                rules={{ required: 'email' }}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.email })}>
                                        </label>
                                        <InputText
                                            id={field.name}
                                            {...field}
                                            placeholder='E-mail'
                                            inputMode="email"
                                            className={classNames("flex-1 border-2 border-round-2xl border-logo-main outline-none bg-transparent appearance-none text-gray-700 w-20rem px-3 py-2", { 'p-invalid': fieldState.error })}
                                            autoComplete="on"
                                        />
                                        {getFormErrorMessage(field.name)}
                                    </>
                                )}
                            />
                            <Controller
                                name="password"
                                control={form.control}
                                rules={{ required: 'A senha é obrigatória' }}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.password })}></label>
                                        <Password
                                            inputId={field.name}
                                            {...field}
                                            placeholder='Senha'
                                            inputClassName="flex-1 border-2 border-round-2xl border-logo-main outline-none bg-transparent appearance-none text-gray-700 w-20rem px-3 py-2"
                                            className={classNames("", { 'p-invalid': fieldState.error })}
                                            feedback={true}
                                            toggleMask={true}
                                            promptLabel="Informe sua senha"
                                            weakLabel="Tá indo bem..."
                                            mediumLabel="Médio"
                                            strongLabel="Essa é boa!"
                                            autoComplete="on"
                                            pt={{ showIcon: { className: 'mr-2' }, hideIcon: { className: 'mr-2' } }}
                                        />
                                        {getFormErrorMessage(field.name)}
                                    </>
                                )}
                            />
                            <Controller
                                name="password_repeat"
                                control={form.control}
                                rules={{
                                    required: 'A senha é obrigatória'
                                }}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.password })}></label>
                                        <Password inputId={field.name} {...field} placeholder='Repita a senha'
                                            inputClassName="flex-1 border-2 border-round-2xl border-logo-main outline-none bg-transparent appearance-none text-gray-700 w-20rem px-3 py-2"
                                            className={classNames("", { 'p-invalid': fieldState.error })}
                                            feedback={false}
                                            toggleMask={true}
                                            autoComplete="off"
                                            pt={{ showIcon: { className: 'mr-2' }, hideIcon: { className: 'mr-2' } }}
                                        />
                                        {getFormErrorMessage(field.name)}
                                    </>
                                )}
                            />
                            <Controller
                                name="termos"
                                control={form.control}
                                rules={{ required: true }}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <div className="flex align-items-center mb-2">
                                        <Checkbox inputId={field.name} {...field} checked={field.value}
                                            className={classNames("border-logo-main ", { 'p-invalid': fieldState.error })}
                                            pt={{
                                                box: { className: 'border-logo-main' },
                                                icon: ({ props }) => ({
                                                    className: classNames('bg-pink-500', { 'hidden': !props.checked })
                                                })
                                            }}
                                        ></Checkbox>
                                        <label htmlFor={field.name} className={classNames("ml-2 text-logo-main", { 'p-error': errors.termos })}>Eu concordo com os termos*</label>
                                    </div>
                                )}
                            />

                            {/* Botão */}
                            <Button id='btnCreateAccount' label="Criar" type="submit" icon={loading ? "pi pi-spin pi-cog" : ""}
                                className="w-full font-bold bg-logo-main border-logo-main line-height-4 text-white border-2 border-solid border-round-2xl"
                            />

                            {/* Links adicionais */}
                            <div className="text-right mt-4">
                                <Link id='login' to="/login" className="text-logo-main no-underline">Login</Link>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}
